import { observer } from 'mobx-react-lite';
import PreviewContainerElement from './PreviewContainerElement';
import type { PreviewContainerElementProps } from './types';

export type { PreviewContainerElementProps };
export default observer(PreviewContainerElement);
